<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'acompanhamentosAnaliseEConsolidados',
                })
            "
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Análise E Consolidado Dos Instrumentos Pedagógicos:
          Planejamento/ Avaliação Da Aprendizagem
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="professor">
        <v-card color="green lighten-1" outlined>
          <v-col cols="10">
            <v-card-text>
              <h4>
                Professor(a):
                {{ professor.nome ? professor.nome : "[CARREGANDO]" }}
              </h4>
              <h4>
                Data de nascimento:
                {{
                  professor.data_nascimento
                    ? new Date(professor.data_nascimento).toLocaleDateString("pt-BR")
                    : "[CARREGANDO]"
                }}
              </h4>
            </v-card-text>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <ValidationObserver v-slot="{ handleSubmit }" v-if="!loading">
          <form @submit.prevent="handleSubmit(saveData)">
            <h3 class="my-4">PLANEJAMENTO/ AVALIAÇÃO DA APRENDIZAGEM</h3>

            <v-row no-gutters>
              <v-col
                v-for="(pergunta, index) in $constants.QUESTOES_ANALISE_E_CONSOLIDADO"
                :key="index"
                cols="12"
                lg="6"
                class="pr-6"
              >
                <ValidationProvider
                  :name="pergunta.label"
                  rules="required|min_value:0|max_value:2"
                  v-slot="{ errors }"
                >
                  <e-label>{{ pergunta.label }}</e-label>
                  <small class="mt-2 d-block">Máximo: 2.0 pontos</small>
                  <v-text-field
                    solo
                    dense
                    type="text"
                    v-model="form[pergunta.campo]"
                    :error-messages="errors"
                    @blur="formatarNota(pergunta.campo)"
                    maxlength="3"
                    class="mt-2"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>

            <v-col cols="12" class="mt-5">
              <v-btn block color="primary" :loading="submitting" type="submit">Salvar</v-btn>
            </v-col>
          </form>
        </ValidationObserver>

        <v-row v-else>
          <v-col cols="12">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader
                class="mx-auto"
                max-width="100%"
                height="100"
                type="paragraph"
              ></v-skeleton-loader>
              <v-skeleton-loader
                class="mx-auto"
                max-width="100%"
                height="100"
                type="paragraph"
              ></v-skeleton-loader
              ><v-skeleton-loader
                class="mx-auto"
                max-width="100%"
                height="100"
                type="paragraph"
              ></v-skeleton-loader
              ><v-skeleton-loader
                class="mx-auto"
                max-width="100%"
                height="100"
                type="paragraph"
              ></v-skeleton-loader>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import ELabel from "../../../components/ELabel.vue";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },
  async mounted() {
    this.loadingPlano = true;
    await this.loadData().then(() => {
      this.loadingPlano = false;
    });
  },
  data() {
    return {
      submitting: false,
      loading: true,
      professor: null,
      loadingPlano: true,
      form: {
        instrutor_id: null,
      },
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    professor_id() {
      return parseInt(this.$route.params.professorId, 10);
    },
    configuracao_id() {
      return parseInt(this.user.franquia.id, 10);
    },
  },
  methods: {
    async saveData() {
      this.submitting = true;
      try {
        this.form.instrutor_id = this.professor_id;
        this.form.configuracao_id = this.configuracao_id;
        await this.$services.acompanhamentosService.createOrUpdateAnaliseEConsolidado(this.form);
        this.$toast.success("Dados salvos com sucesso!");
        this.$router.push({ name: "acompanhamentosAnaliseEConsolidados" });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.submitting = false;
      }
    },
    async loadData() {
      try {
        this.professor = await this.$services.professoresService.show(this.professor_id);
        const response = await this.$services.acompanhamentosService.pegarDadosAnaliseEConsolidado(
          this.professor_id,
          this.configuracao_id
        );
        if (response.acompanhamento) {
          this.form = response.acompanhamento;
        }
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.loading = false;
      }
    },
    formatarNota(campo) {
      let value = this.form[campo];

      // Substitui a vírgula por ponto
      value = value.replace(",", ".");

      // Garante que o valor tenha até 2 dígitos e 1 decimal
      if (value.length > 3) {
        value = value.slice(0, 3); // Limita a 3 caracteres
      }

      // Verifica se o valor é um único dígito e preenche com zero
      if (value.length === 1 && !value.includes(".")) {
        value = `${value}.0`; // Adiciona .0 caso tenha apenas um dígito
      }

      // Garante que o valor seja válido com até 2 dígitos e 1 decimal
      if (value && !/^\d{0,2}(\.\d{0,1})?$/.test(value)) {
        return; // Se a regex falhar, mantém o valor atual sem mudança
      }

      this.form[campo] = value;
    },
  },
};
</script>

<style></style>
